import { Component} from '@angular/core';
import { ActivatedRoute,Router } from "@angular/router";
import { PagesServices } from '../../../pages.services';

@Component({
    selector: 'preview-navigation-left',
    templateUrl: './preview-navigation-left.html',
    styleUrls: ['./preview-navigation-left.scss']
})
export class PreviewNavigationLeft {

    constructor(
        private _route: ActivatedRoute,
        private _pagesService: PagesServices,
        private _router: Router,) {
       
    }


    disabled: boolean =  false;
    datas:any;
    position:number = -1;
    folderId:any = "";
    bookmarkId:any = null;
    preload:boolean = true;

    ngOnInit(){
        this.datas = this._pagesService.GetNavigationPreviewData();
        let ids = this.datas .map(d => d.id);
        this._route.queryParams.subscribe(params => {
            let id = params['Id'];
            if(params['folderId'] != undefined){
                this.folderId = "&folderId="+params['folderId'];
            }
            this.position = ids.indexOf(id);
            
            if(this.position <= 0)
            this.disabled = true;
            else this.disabled = false;
        });

        setTimeout(() => {
            this.preload = false;
        }, 2000);
    }

    NavigatetoPreviousPage(){
        if(!this.disabled){
            var previousPage = this.datas[this.position-1];
            history.back();
            let module = 'my-files';
            if(window.location.href.indexOf('all-files') > 0){
                module = 'all-files';
            }
            else if(window.location.href.indexOf('my-folder-files') > 0){
                module = 'my-folder-files';
            }
            else if(window.location.href.indexOf('recycle-bin') > 0){
                module = 'recycle-bin';
            }

            setTimeout(() => {
                switch (previousPage.fileType.toLowerCase()) {
                    case "audio":
                        window.location.href = window.location.origin + '#/pages/'+module+'/audio-preview?Id=' + previousPage.id + this.folderId;
                        break;
                    case "video":
                        window.location.href = window.location.origin + '#/pages/'+module+'/video-preview?Id=' + previousPage.id + this.folderId;
                        break;
                    case "photo":
                        window.location.href = window.location.origin + '#/pages/'+module+'/photo-preview?Id=' + previousPage.id + this.folderId;
                        break;
                    case "document":
                        window.location.href = window.location.origin + '#/pages/'+module+'/document-preview?Id=' + previousPage.id + this.folderId;
                        break;
                }
    
            }, 50);
        }
    }

}